/* istanbul ignore file */

export enum UserSelectablePresetColors {
    SolidRed = "#EC4B3C",
    SolidOrange = "#FE9900",
    SolidYellow = "#FFFF01",
    SolidGreen = "#2FE42F",
    SolidAqua = "#6EE1F0",
    SolidBlue = "#235BEC",
    SolidPurple = "#C024EB",
    SolidGray = "#D9DADD",
    TransparentRed = "#FFD3D0",
    TransparentOrange = "#FFE1B3",
    TransparentYellow = "#FFFFB3",
    TransparentGreen = "#CDECCD",
    TransparentBlue = "#CFDDFF",
    TransparentPurple = "#E7CCEF",
    Transparent = "transparent",
    DefaultAppColor = "#592c82",
    Black = "#212121",
    White = "#FFFFFF",
}

export enum UserSelectablePresetColorsClasses {
    SolidRed = "khts-solid-red",
    SolidOrange = "khts-solid-orange",
    SolidYellow = "khts-solid-yellow",
    SolidGreen = "khts-solid-green",
    SolidAqua = "khts-solid-aqua",
    SolidBlue = "khts-solid-blue",
    SolidPurple = "khts-solid-purple",
    SolidGray = "khts-solid-gray",
    TransparentRed = "khts-transparent-red",
    TransparentOrange = "khts-transparent-orange",
    TransparentYellow = "khts-transparent-yellow",
    TransparentGreen = "khts-transparent-green",
    TransparentBlue = "khts-transparent-blue",
    TransparentPurple = "khts-transparent-purple",
    Transparent = "khts-transparent",
    AppColor = "khts-app-theme-color",
    DefaultAppColor = "khts-app-theme-color",
    Black = "khts-black",
    White = "khts-white",
}
